import { Authentication, Locales, System, Theme } from '@/constants'

export function getBearerToken(): string {
  return `Bearer ${getAccessToken()}`
}

export function getAccessToken(): string | null {
  return localStorage.getItem(Authentication.AccessToken)
}

export function setAccessToken(accessToken: string): void {
  localStorage.setItem(Authentication.AccessToken, accessToken)
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(Authentication.RefreshToken)
}

export function setRefreshToken(refreshToken: string): void {
  localStorage.setItem(Authentication.RefreshToken, refreshToken)
}

export function getExpiryIn(): string | null {
  return localStorage.getItem(Authentication.ExpiryIn)
}

export function setExpiryIn(expiryIn: string): void {
  localStorage.setItem(Authentication.ExpiryIn, expiryIn)
}

export function saveToken(accessToken: string, refreshToken: string, expiryIn: string): void {
  setAccessToken(accessToken)
  setRefreshToken(refreshToken)
  setExpiryIn(expiryIn)
}

export function getLayout(): string | null {
  return sessionStorage.getItem(System.Layout)
}

export function setLayout(layout: string): void {
  sessionStorage.setItem(System.Layout, layout)
}

export function destroySensitiveInfo(): void {
  localStorage.removeItem(Authentication.AccessToken)
  localStorage.removeItem(Authentication.RefreshToken)
  localStorage.removeItem(Authentication.ExpiryIn)
  sessionStorage.removeItem(System.Layout)
}

export function getLocale(): string {
  return localStorage.getItem(System.Locale) || Locales.EN
}

export function setLocale(locale: string): void {
  localStorage.setItem(System.Locale, locale)
}

export function getTheme(): string {
  return localStorage.getItem(System.Theme) || Theme.Light
}

export function setTheme(theme: string): void {
  localStorage.setItem(System.Theme, theme)
}
